import { z } from 'zod';

/**
 * Branded UUID identifier for a task. Kept in its own module so
 * sibling schemas (e.g. `BlockReasonSchema`) can depend on it without
 * pulling the full {@link TaskSchema} cycle.
 */
export const TaskIdSchema = z.guid().brand<'TaskId'>();

export type TaskId = z.infer<typeof TaskIdSchema>;
